var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"disabled":_vm.disabled,"items":_vm.optionList,"ruleList":_vm.ruleList,"rules":_vm.ruleList,"clearable":"","item-text":"label","item-value":"id","outlined":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }